/** comp: the composition editor. English + Arabic (Arabic is a draft for native review). */
const en = {
  back: 'Back to Content',
  nameLabel: 'Composition name',
  untitled: 'Untitled composition',
  unsaved: 'Unsaved changes',
  allSaved: 'All changes saved',
  saved: 'Saved “{name}”',
  leaveQ: 'Leave without saving your changes to this composition?',
  notComposition: 'This item is not a composition.',
  undo: 'Undo',
  redo: 'Redo',
  preview: 'Preview',
  publish: 'Publish',
  savePublish: 'Save & Publish',
  previewHint: 'This is how screens show it: clocks run, feeds cycle, videos play.',
  saveTemplate: 'Save as template',
  templateName: 'Name of the template',
  templateSaved: 'Saved the template “{name}”',
  deleteTemplate: 'Delete the template {name}',
  deleteTemplateQ: 'Delete the template “{name}”? Compositions made from it stay as they are.',
  newTitle: 'New composition',
  newHint: 'Start from a template. You can change everything afterwards.',
  starter: 'Starter',
  yourTemplate: 'Your template',
  add: 'Add',
  design: 'Design',
  layers: 'Layers',
  noLayers: 'Nothing on the canvas yet. Add text, shapes or pictures from the left.',
  tip: 'Click an element to select it. Drag to move, double-click text to type. Alt turns snapping off.',
  zoom: 'Zoom',
  fit: 'Fit',
  forward: 'Forward',
  backward: 'Backward',
  duplicate: 'Duplicate',
  rotate: 'Rotate (Shift: 15° steps)',
  alignCanvas_left: 'Align to the left edge',
  alignCanvas_hcenter: 'Centre horizontally',
  alignCanvas_right: 'Align to the right edge',
  alignCanvas_top: 'Align to the top',
  alignCanvas_vcenter: 'Centre vertically',
  alignCanvas_bottom: 'Align to the bottom',
  kind_text: 'Text',
  kind_shape: 'Shape',
  kind_sticker: 'Sticker',
  "uploadPicture": "Upload a picture",
  "uploadVideo": "Upload a video",
  "dropPictures": "Pick one below, or drop pictures here to upload. A single upload goes straight onto the canvas once it's ready.",
  "dropVideos": "Pick one below, or drop videos here to upload. A single upload goes straight onto the canvas once it's ready.",
  "uploading": "Uploading",
  "optimizing": "Getting it ready",
  "uploadFailed": "Upload failed",
  "notAPicture": "Not a picture",
  "notAVideo": "Not a video",
  "kind_drawing": "Draw",
  "penOptions": "Pen",
  "penHint": "Drag on the canvas to draw. Each stroke can be moved, resized or deleted.",
  "otherColor": "Other colour",
  "thickness": "Thickness",
  "penDone": "Done drawing",
  "penHide": "Hide pen options (keep drawing)",
  "penShow": "Show pen options",
  kind_image: 'Picture',
  kind_video: 'Video',
  kind_clock: 'Clock',
  kind_date: 'Date',
  kind_countdown: 'Countdown',
  kind_qr: 'QR code',
  kind_weather: 'Weather',
  canvas: 'Canvas',
  size: 'Size',
  custom: 'Custom size',
  width: 'Width',
  height: 'Height',
  x: 'X',
  y: 'Y',
  background: 'Background',
  bgImage: 'Background picture…',
  removeBg: 'Remove the background picture',
  duration: 'Time on screen (seconds)',
  durationHint: 'How long it stays on screen in a player’s list or a playlist.',
  feeds: 'Data Feeds',
  feedsHint: 'Show live rows from a Data Feed in texts and pictures. Cycling steps through the rows.',
  feedGone: 'A deleted feed',
  rows: 'No rows yet | {n} row | {n} rows',
  cycle: 'Step through rows every',
  seconds: 'seconds',
  addFeed: 'Add a Data Feed…',
  noFeeds: 'No Data Feeds yet. Create one in Data Feeds to show live rows here.',
  name: 'Layer name',
  lock: 'Lock',
  unlock: 'Unlock',
  locked: 'Locked',
  lockedHint: 'Locked by an admin: you can see it, but only an admin can change it.',
  show: 'Show',
  hide: 'Hide',
  text: 'Text',
  shape: 'Shape',
  shape_rect: 'Rectangle',
  shape_ellipse: 'Ellipse',
  shape_line: 'Line',
  fill: 'Fill',
  noFill: 'No fill',
  addFill: 'Fill',
  stroke: 'Outline',
  strokeWidth: 'Outline width',
  radius: 'Rounded corners',
  sticker: 'Sticker',
  color: 'Colour',
  label: 'Label',
  change: 'change',
  none: 'None',
  missingMedia: 'Missing item',
  fit_cover: 'Fill',
  fit_contain: 'Fit',
  fit_fill: 'Stretch',
  sound: 'Play its sound',
  format: 'Format',
  clockStyle: 'Clock style',
  clock_digital: 'Digital',
  clock_analog: 'Analog',
  analogHint: 'Colour draws the hands and ticks, box colour fills the dial; the 14:30:05 format adds a seconds hand.',
  date_long: 'Monday, 31 December 2026',
  date_short: '31 December 2026',
  date_weekday: 'Monday',
  language: 'Language',
  until: 'Count down to',
  showSeconds: 'Show seconds',
  doneText: 'Text when it’s over',
  qrData: 'Link or text',
  screenLocation: 'Use each screen’s location',
  lat: 'Latitude',
  lon: 'Longitude',
  units: 'Units',
  icon: 'Icon',
  weatherHint: 'Updated every 30 minutes while the screen is online; the last value stays when it is offline.',
  textStyle: 'Text',
  font: 'Font',
  family_sans: 'Sans',
  family_serif: 'Serif',
  family_mono: 'Monospace',
  family_display: 'Display (bold)',
  fontSize: 'Size',
  bold: 'Bold',
  italic: 'Italic',
  align_left: 'Align left',
  align_center: 'Centre',
  align_right: 'Align right',
  valign_top: 'Top',
  valign_middle: 'Middle',
  valign_bottom: 'Bottom',
  lineHeight: 'Line height',
  boxColor: 'Box colour',
  fromFeed: 'Show from a Data Feed',
  fromFeedHint: 'Add a Data Feed to the canvas first (click an empty part of the canvas).',
  feed: 'Data Feed',
  notFromFeed: 'No — show my own content',
  column: 'Column',
  row: 'Row',
  rowOffset: 'Row (1 = current)',
  feedImageHint: 'Pictures from a feed load when the screen is online; otherwise the picture chosen above shows.',
  position: 'Position',
  rotation: 'Rotation (°)',
  opacity: 'Opacity',
  pickImage: 'Choose a picture',
  pickVideo: 'Choose a video',
  search: 'Search',
  noImages: 'No ready pictures in Content yet. Upload one first.',
  noVideos: 'No ready videos in Content yet. Upload one first.',
  // Content library
  type: 'Composition',
  newItem: 'Composition',
  newItemHint: 'Design a screen: text, pictures, clocks, live data',
  list: 'Compositions ({n})',
  open: 'Open the editor',
  bundle: 'Players download {size}',
};
const ar: typeof en = {
  back: 'العودة إلى المحتوى',
  nameLabel: 'اسم التصميم',
  untitled: 'تصميم بدون عنوان',
  unsaved: 'تغييرات غير محفوظة',
  allSaved: 'تم حفظ كل التغييرات',
  saved: 'تم حفظ «{name}»',
  leaveQ: 'المغادرة دون حفظ تغييراتك على هذا التصميم؟',
  notComposition: 'هذا العنصر ليس تصميمًا.',
  undo: 'تراجع',
  redo: 'إعادة',
  preview: 'معاينة',
  publish: 'نشر',
  savePublish: 'حفظ ونشر',
  previewHint: 'هكذا تعرضه الشاشات: الساعات تعمل، وبيانات المصادر تتبدل، ومقاطع الفيديو تُشغَّل.',
  saveTemplate: 'حفظ كقالب',
  templateName: 'اسم القالب',
  templateSaved: 'تم حفظ القالب «{name}»',
  deleteTemplate: 'حذف القالب {name}',
  deleteTemplateQ: 'حذف القالب «{name}»؟ تبقى التصاميم التي أُنشئت منه كما هي.',
  newTitle: 'تصميم جديد',
  newHint: 'ابدأ من قالب. يمكنك تغيير كل شيء بعد ذلك.',
  starter: 'قالب جاهز',
  yourTemplate: 'قالبك',
  add: 'إضافة',
  design: 'التصميم',
  layers: 'الطبقات',
  noLayers: 'لا يوجد شيء على اللوحة بعد. أضف نصًا أو أشكالًا أو صورًا من اليسار.',
  tip: 'انقر عنصرًا لتحديده. اسحب للتحريك، وانقر النص مرتين للكتابة. مفتاح Alt يوقف المحاذاة التلقائية.',
  zoom: 'التكبير',
  fit: 'ملاءمة',
  forward: 'للأمام',
  backward: 'للخلف',
  duplicate: 'تكرار',
  rotate: 'تدوير (Shift: خطوات 15°)',
  alignCanvas_left: 'محاذاة إلى الحافة اليسرى',
  alignCanvas_hcenter: 'توسيط أفقي',
  alignCanvas_right: 'محاذاة إلى الحافة اليمنى',
  alignCanvas_top: 'محاذاة إلى الأعلى',
  alignCanvas_vcenter: 'توسيط عمودي',
  alignCanvas_bottom: 'محاذاة إلى الأسفل',
  kind_text: 'نص',
  kind_shape: 'شكل',
  kind_sticker: 'ملصق',
  "uploadPicture": "رفع صورة",
  "uploadVideo": "رفع فيديو",
  "dropPictures": "اختر واحدة أدناه، أو أفلت الصور هنا لرفعها. الرفع الواحد يوضع على اللوحة مباشرة عند جاهزيته.",
  "dropVideos": "اختر واحدًا أدناه، أو أفلت مقاطع الفيديو هنا لرفعها. الرفع الواحد يوضع على اللوحة مباشرة عند جاهزيته.",
  "uploading": "جارٍ الرفع",
  "optimizing": "جارٍ التجهيز",
  "uploadFailed": "فشل الرفع",
  "notAPicture": "ليست صورة",
  "notAVideo": "ليس فيديو",
  "kind_drawing": "رسم",
  "penOptions": "القلم",
  "penHint": "اسحب على اللوحة للرسم. يمكن نقل كل خط أو تغيير حجمه أو حذفه.",
  "otherColor": "لون آخر",
  "thickness": "السُمك",
  "penDone": "إنهاء الرسم",
  "penHide": "إخفاء خيارات القلم (مع متابعة الرسم)",
  "penShow": "إظهار خيارات القلم",
  kind_image: 'صورة',
  kind_video: 'فيديو',
  kind_clock: 'ساعة',
  kind_date: 'تاريخ',
  kind_countdown: 'عدّ تنازلي',
  kind_qr: 'رمز QR',
  kind_weather: 'الطقس',
  canvas: 'اللوحة',
  size: 'الحجم',
  custom: 'حجم مخصص',
  width: 'العرض',
  height: 'الارتفاع',
  x: 'س',
  y: 'ص',
  background: 'الخلفية',
  bgImage: 'صورة الخلفية…',
  removeBg: 'إزالة صورة الخلفية',
  duration: 'مدة العرض (ثوانٍ)',
  durationHint: 'كم يبقى على الشاشة في قائمة المشغّل أو في قائمة تشغيل.',
  feeds: 'مصادر البيانات',
  feedsHint: 'اعرض صفوفًا حية من مصدر بيانات في النصوص والصور. التبديل ينتقل بين الصفوف.',
  feedGone: 'مصدر محذوف',
  rows: 'لا توجد صفوف بعد | صف واحد | صفان | {n} صفوف | {n} صفًا | {n} صف',
  cycle: 'الانتقال بين الصفوف كل',
  seconds: 'ثانية',
  addFeed: 'إضافة مصدر بيانات…',
  noFeeds: 'لا توجد مصادر بيانات بعد. أنشئ واحدًا في مصادر البيانات لعرض صفوف حية هنا.',
  name: 'اسم الطبقة',
  lock: 'قفل',
  unlock: 'فتح القفل',
  locked: 'مقفل',
  lockedHint: 'قفله مسؤول: يمكنك رؤيته، لكن لا يغيّره إلا مسؤول.',
  show: 'إظهار',
  hide: 'إخفاء',
  text: 'النص',
  shape: 'الشكل',
  shape_rect: 'مستطيل',
  shape_ellipse: 'شكل بيضاوي',
  shape_line: 'خط',
  fill: 'التعبئة',
  noFill: 'بدون تعبئة',
  addFill: 'تعبئة',
  stroke: 'الحد',
  strokeWidth: 'عرض الحد',
  radius: 'زوايا مستديرة',
  sticker: 'الملصق',
  color: 'اللون',
  label: 'العنوان',
  change: 'تغيير',
  none: 'بدون',
  missingMedia: 'عنصر مفقود',
  fit_cover: 'ملء',
  fit_contain: 'احتواء',
  fit_fill: 'تمديد',
  sound: 'تشغيل الصوت',
  format: 'التنسيق',
  clockStyle: 'نوع الساعة',
  clock_digital: 'رقمية',
  clock_analog: 'بعقارب',
  analogHint: 'اللون يرسم العقارب والعلامات، ولون المربع يملأ الوجه؛ تنسيق 14:30:05 يضيف عقرب الثواني.',
  date_long: 'الاثنين، 31 ديسمبر 2026',
  date_short: '31 ديسمبر 2026',
  date_weekday: 'الاثنين',
  language: 'اللغة',
  until: 'العدّ حتى',
  showSeconds: 'إظهار الثواني',
  doneText: 'النص عند الانتهاء',
  qrData: 'رابط أو نص',
  screenLocation: 'استخدام موقع كل شاشة',
  lat: 'خط العرض',
  lon: 'خط الطول',
  units: 'الوحدات',
  icon: 'الأيقونة',
  weatherHint: 'يُحدَّث كل 30 دقيقة ما دامت الشاشة متصلة؛ وتبقى آخر قيمة عند انقطاع الاتصال.',
  textStyle: 'النص',
  font: 'الخط',
  family_sans: 'بدون زوائد',
  family_serif: 'بزوائد',
  family_mono: 'ثابت العرض',
  family_display: 'عريض للعناوين',
  fontSize: 'الحجم',
  bold: 'عريض',
  italic: 'مائل',
  align_left: 'محاذاة لليسار',
  align_center: 'توسيط',
  align_right: 'محاذاة لليمين',
  valign_top: 'أعلى',
  valign_middle: 'وسط',
  valign_bottom: 'أسفل',
  lineHeight: 'ارتفاع السطر',
  boxColor: 'لون المربع',
  fromFeed: 'العرض من مصدر بيانات',
  fromFeedHint: 'أضف مصدر بيانات إلى اللوحة أولًا (انقر جزءًا فارغًا من اللوحة).',
  feed: 'مصدر البيانات',
  notFromFeed: 'لا — اعرض المحتوى الخاص بي',
  column: 'العمود',
  row: 'الصف',
  rowOffset: 'الصف (1 = الحالي)',
  feedImageHint: 'تُحمَّل صور المصدر عندما تكون الشاشة متصلة؛ وإلا تظهر الصورة المختارة أعلاه.',
  position: 'الموضع',
  rotation: 'التدوير (°)',
  opacity: 'الشفافية',
  pickImage: 'اختيار صورة',
  pickVideo: 'اختيار فيديو',
  search: 'بحث',
  noImages: 'لا توجد صور جاهزة في المحتوى بعد. ارفع صورة أولًا.',
  noVideos: 'لا توجد مقاطع فيديو جاهزة في المحتوى بعد. ارفع مقطعًا أولًا.',
  type: 'تصميم',
  newItem: 'تصميم',
  newItemHint: 'صمّم شاشة: نصوص وصور وساعات وبيانات حية',
  list: 'التصاميم ({n})',
  open: 'فتح المحرر',
  bundle: 'تنزّل الشاشات {size}',
};
export default { en, ar };
